<template>
    <div id="section-block" class="page-blockui">
        <div class="row" id="credit_scores_step">
            <div class="col-xl-12 col-md-12 col-12 mx-auto">
                <power-of-attorney/>
            </div>
            <div class="col-xl-12 col-md-12 col-12 mx-auto">
                <div class="card card-statistics">
                    <div class="card-header mx-auto">
                        <h3 class="card-title text-primary">Credit Scores</h3>
                    </div>
                    <div class="card-body statistics-body client-dashboard">
                        <credit-scores :client-email="userStore.user.email" />
                    </div>
                </div>
            </div>
        </div>
        <div class="row" id="letter_client_step">
            <div class="col-xl-12 col-md-12 col-smd-12 ">
                <div class="card" id="tour_tracker">
                    <div class="card-content">
                        <div class="card-body text-left">
                            <dispute-tracker></dispute-tracker>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
    import PowerOfAttorney from "./PowerOfAttorney.vue"
    import { useClientStore } from "../../stores/ClientStore.js";
    import { useUserStore } from "../../stores/UserStore.js";
    export default {
        components: {
            PowerOfAttorney
        },
        setup(){
            return{
                clientStore : useClientStore(),
                userStore : useUserStore()
            }
        },
        mounted(){

        },
        methods:{
        }
    }
</script>
